import styled from 'styled-components'
import { MEDIA } from './Framework'

const Main = styled.main`
  ${MEDIA.lg} {
    margin-left: 250px;
  }
`

export default Main
